<template>
  <div>
    <v-app>
      <a href="#main-content" class="skip-link">Skip to main content</a>

      <!-- Put this anywhere in your <template>, often right below <v-app> or at the end -->
      <v-dialog v-model="dialogLegend" max-width="600px" scrollable persistent>
        <v-card role="dialog" aria-labelledby="legend-title" aria-modal="true">
          <v-card-title class="legend-dialog-title">
            <span id="legend-title">Icon Legend</span>
            <v-spacer></v-spacer>
            <v-btn
              icon
              @click="dialogLegend = false"
              aria-label="Close icon legend dialog"
            >
              <v-icon aria-hidden="true">mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text>
            <ul class="icon-legend-grid">
              <li class="icon-legend-item">
                <img
                  src="../assets/newHomeIcons/IconLegend/restroom.svg"
                  alt=""
                  aria-hidden="true"
                />
                <span>Restrooms</span>
              </li>
              <li class="icon-legend-item">
                <img
                  src="../assets/newHomeIcons/IconLegend/camping.svg"
                  alt=""
                  aria-hidden="true"
                />
                <span>Camping</span>
              </li>
              <li class="icon-legend-item">
                <img
                  src="../assets/newHomeIcons/IconLegend/dump-station.svg"
                  alt=""
                  aria-hidden="true"
                />
                <span>Dump Station</span>
              </li>
              <li class="icon-legend-item">
                <img
                  src="../assets/newHomeIcons/IconLegend/dogs.svg"
                  alt=""
                  aria-hidden="true"
                />
                <span>Dogs Allowed</span>
              </li>
              <li class="icon-legend-item">
                <img
                  src="../assets/newHomeIcons/IconLegend/hiking.svg"
                  alt=""
                  aria-hidden="true"
                />
                <span>Hiking</span>
              </li>
              <li class="icon-legend-item">
                <img
                  src="../assets/newHomeIcons/IconLegend/swimming.svg"
                  alt=""
                  aria-hidden="true"
                />
                <span>Swimming</span>
              </li>
              <li class="icon-legend-item">
                <img
                  src="../assets/newHomeIcons/IconLegend/boat-launch.svg"
                  alt=""
                  aria-hidden="true"
                />
                <span>Boating</span>
              </li>
              <li class="icon-legend-item">
                <img
                  src="../assets/newHomeIcons/IconLegend/fishing.svg"
                  alt=""
                  aria-hidden="true"
                />
                <span>Fishing</span>
              </li>
              <li class="icon-legend-item">
                <img
                  src="../assets/newHomeIcons/IconLegend/kayaking.svg"
                  alt=""
                  aria-hidden="true"
                />
                <span>Kayaking</span>
              </li>
              <!-- <li class="icon-legend-item">
                <img
                  src="../assets/newHomeIcons/IconLegend/wifi.svg"
                  alt=""
                  aria-hidden="true"
                />
                <span>Free WiFi</span>
              </li> -->
              <li class="icon-legend-item">
                <img
                  src="../assets/newHomeIcons/IconLegend/wheelchair.svg"
                  alt=""
                  aria-hidden="true"
                />
                <span>Wheelchair Accessible</span>
              </li>
              <li class="icon-legend-item">
                <img
                  src="../assets/newHomeIcons/IconLegend/picnic.svg"
                  alt=""
                  aria-hidden="true"
                />
                <span>Picnic Area</span>
              </li>
              <li class="icon-legend-item">
                <img
                  src="../assets/newHomeIcons/IconLegend/campfire.svg"
                  alt=""
                  aria-hidden="true"
                />
                <span>Firepits</span>
              </li>
              <li class="icon-legend-item">
                <img
                  src="../assets/newHomeIcons/IconLegend/museum.svg"
                  alt=""
                  aria-hidden="true"
                />
                <span>Museum</span>
              </li>
              <li class="icon-legend-item">
                <img
                  src="../assets/newHomeIcons/IconLegend/golfing.svg"
                  alt=""
                  aria-hidden="true"
                />
                <span>Golfing</span>
              </li>
            </ul>
          </v-card-text>
        </v-card>
      </v-dialog>

      <Header v-if="!mobileSearch" />
      <div v-if="mobileSearch == true" class="blackBack">
        <div class="search-page-wrap">
          <p class="searchHeader">Search a Utah State Park</p>
          <button
            class="white-x-btn"
            @click="mobileSearch = false"
            aria-label="Close search"
          >
            <img
              class="white-x"
              src="../assets/icons/whitex.png"
              alt=""
              aria-hidden="true"
            />
          </button>
          <div class="searchBox" style="width: 100%; box-sizing: border-box">
            <v-autocomplete
              id="autocomplete-mobile"
              @load="mobileSearchLoaded()"
              @change="locationSelected()"
              @focus="searchFocus()"
              @blur="searchBlur()"
              v-model="park"
              auto-select-first
              background-color="#727A35"
              dark
              color="#FFFFFF"
              :menu-props="{ bottom: true, offsetY: true, maxHeight: 220 }"
              item-text="name"
              placeholder="Find your destination..."
              :items="parks"
              filled
              :rounded="!searchFocused"
              class="select-park-mobile"
              aria-label="Search for a Utah State Park"
              aria-expanded="false"
              aria-autocomplete="list"
              role="combobox"
            >
              <template v-slot:append>
                <v-icon
                  color="white"
                  style="margin-right: 8px"
                  aria-hidden="true"
                  >mdi-magnify</v-icon
                >
              </template>
            </v-autocomplete>
          </div>
        </div>
      </div>
      <div
        v-bind:style="{ backgroundImage: 'url(' + homeHeroImg + ')' }"
        v-else
        role="img"
        aria-label="Scenic view of Snow Canyon State Park with red rock formations and blue sky"
      >
        <main id="main-content">
          <div id="homeImgContainer">
            <div class="centered-home">
              <!-- <h2 class="home1">PLAN YOUR TRIP AHEAD!</h2> -->
              <h1 class="home2">Digital Utah State Park Passes</h1>
              <h2 class="home3">Buy day-use passes online.</h2>
              <v-autocomplete
                id="autocomplete"
                @change="locationSelected()"
                @focus="searchFocus()"
                @blur="searchBlur()"
                v-model="park"
                auto-select-first
                background-color="#727A35"
                dark
                color="#FFFFFF"
                :menu-props="{ bottom: true, offsetY: true }"
                item-text="name"
                placeholder="Find your destination..."
                :items="parks"
                filled
                :rounded="!searchFocused"
                class="select-park"
                role="combobox"
                aria-label="Search for a Utah State Park"
                aria-expanded="false"
                aria-autocomplete="list"
              >
                <template v-slot:append>
                  <v-icon
                    color="white"
                    style="margin-right: 8px"
                    aria-hidden="true"
                    >mdi-magnify</v-icon
                  >
                </template>
              </v-autocomplete>
              <a class="park-events-link" href="https://events.parkspass.app/">
                Open Park Events
                <img
                  src="../assets/icons/open.svg"
                  alt=""
                  aria-hidden="true"
                  class="park-events-icon"
                />
              </a>
            </div>
          </div>

          <div id="page-padding">
            <nav id="filter-menu" aria-label="Filter parks by activity">
              <ul class="filter-list">
                <li v-for="(filter, index) in filterItems" :key="index">
                  <button
                    class="filter-item"
                    :class="{ 'active-filter': selectedFilter === filter.name }"
                    @click="selectedFilter = filter.name"
                    :aria-pressed="(selectedFilter === filter.name).toString()"
                    :aria-label="`Filter by ${filter.name}`"
                  >
                    <img :src="filter.icon" :alt="''" aria-hidden="true" />
                    <span class="filter-text">{{ filter.name }}</span>
                  </button>
                </li>
              </ul>
            </nav>

            <div id="above-passes">
              <h2 class="subheading">Available Day-Use Passes</h2>
              <div id="above-passes2">
                <button
                  id="legend"
                  @click="dialogLegend = true"
                  aria-label="Open icon legend"
                >
                  Icon Legend
                </button>
                <p id="location-num" aria-live="polite">
                  {{ filteredParks.length }} Locations
                </p>
              </div>
            </div>

            <div id="bottom-section">
              <section id="passes" aria-label="Available parks">
                <article
                  class="park-card"
                  role="article"
                  :aria-labelledby="'park-name-' + park.abbr"
                  v-for="park in filteredParks"
                  :key="park.abbr"
                >
                  <img
                    class="park-images"
                    :src="require(`@/assets/HomeImages/${park.image}`)"
                    :alt="`${park.name} park scenery`"
                  />
                  <div class="card-text-cont">
                    <div class="location">
                      <img
                        src="../assets/newHomeIcons/location.svg"
                        alt="location pin icon"
                        aria-hidden="true"
                      />
                      <p class="location-text">{{ park.location }}</p>
                    </div>
                    <h3 class="park-name" :id="'park-name-' + park.abbr">
                      {{ park.name }}
                    </h3>
                    <p class="pass-type">{{ park.type }}</p>
                    <div class="icons" role="list" aria-label="Park amenities">
                      <v-tooltip
                        v-if="park.restrooms"
                        bottom
                        dark
                        color="grey darken-3"
                        content-class="my-tooltip"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <span role="listitem">
                            <img
                              class="amen-icon"
                              src="../assets/newHomeIcons/IconLegend/restroom.svg"
                              alt="Restrooms available"
                              v-bind="attrs"
                              v-on="on"
                            />
                          </span>
                        </template>
                        <span>Restrooms</span>
                      </v-tooltip>

                      <v-tooltip
                        v-if="park.camping"
                        bottom
                        dark
                        color="grey darken-3"
                        content-class="my-tooltip"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <span role="listitem">
                            <img
                              class="amen-icon"
                              src="../assets/newHomeIcons/IconLegend/camping.svg"
                              alt="Camping available"
                              v-bind="attrs"
                              v-on="on"
                            />
                          </span>
                        </template>
                        <span>Camping</span>
                      </v-tooltip>

                      <v-tooltip
                        v-if="park.dumpStation"
                        bottom
                        dark
                        color="grey darken-3"
                        content-class="my-tooltip"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <span role="listitem">
                            <img
                              class="amen-icon"
                              src="../assets/newHomeIcons/IconLegend/dump-station.svg"
                              alt="Dump Station available"
                              v-bind="attrs"
                              v-on="on"
                            />
                          </span>
                        </template>
                        <span>Dump Station</span>
                      </v-tooltip>

                      <v-tooltip
                        v-if="park.dogsAllowed"
                        bottom
                        dark
                        color="grey darken-3"
                        content-class="my-tooltip"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <span role="listitem">
                            <img
                              class="amen-icon"
                              src="../assets/newHomeIcons/IconLegend/dogs.svg"
                              alt="Dogs allowed"
                              v-bind="attrs"
                              v-on="on"
                            />
                          </span>
                        </template>
                        <span>Dogs Allowed</span>
                      </v-tooltip>

                      <v-tooltip
                        v-if="park.hiking"
                        bottom
                        dark
                        color="grey darken-3"
                        content-class="my-tooltip"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <span role="listitem">
                            <img
                              class="amen-icon"
                              src="../assets/newHomeIcons/IconLegend/hiking.svg"
                              alt="Hiking available"
                              v-bind="attrs"
                              v-on="on"
                            />
                          </span>
                        </template>
                        <span>Hiking</span>
                      </v-tooltip>

                      <v-tooltip
                        v-if="park.swimming"
                        bottom
                        dark
                        color="grey darken-3"
                        content-class="my-tooltip"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <span role="listitem">
                            <img
                              class="amen-icon"
                              src="../assets/newHomeIcons/IconLegend/swimming.svg"
                              alt="Swimming available"
                              v-bind="attrs"
                              v-on="on"
                            />
                          </span>
                        </template>
                        <span>Swimming</span>
                      </v-tooltip>

                      <v-tooltip
                        v-if="park.boating"
                        bottom
                        dark
                        color="grey darken-3"
                        content-class="my-tooltip"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <span role="listitem">
                            <img
                              class="amen-icon"
                              src="../assets/newHomeIcons/IconLegend/boat-launch.svg"
                              alt="Boating available"
                              v-bind="attrs"
                              v-on="on"
                            />
                          </span>
                        </template>
                        <span>Boating</span>
                      </v-tooltip>

                      <v-tooltip
                        v-if="park.fishing"
                        bottom
                        dark
                        color="grey darken-3"
                        content-class="my-tooltip"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <span role="listitem">
                            <img
                              class="amen-icon"
                              src="../assets/newHomeIcons/IconLegend/fishing.svg"
                              alt="Fishing available"
                              v-bind="attrs"
                              v-on="on"
                            />
                          </span>
                        </template>
                        <span>Fishing</span>
                      </v-tooltip>

                      <v-tooltip
                        v-if="park.kayaking"
                        bottom
                        dark
                        color="grey darken-3"
                        content-class="my-tooltip"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <span role="listitem">
                            <img
                              class="amen-icon"
                              src="../assets/newHomeIcons/IconLegend/kayaking.svg"
                              alt="Kayaking available"
                              v-bind="attrs"
                              v-on="on"
                            />
                          </span>
                        </template>
                        <span>Kayaking</span>
                      </v-tooltip>

                      <!-- <v-tooltip
                        v-if="park.wifi"
                        bottom
                        dark
                        color="grey darken-3"
                        content-class="my-tooltip"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <span role="listitem">
                            <img
                              class="amen-icon"
                              src="../assets/newHomeIcons/IconLegend/wifi.svg"
                              alt="WiFi available"
                              v-bind="attrs"
                              v-on="on"
                            />
                          </span>
                        </template>
                        <span>WiFi</span>
                      </v-tooltip> -->

                      <v-tooltip
                        v-if="park.wheelChair"
                        bottom
                        dark
                        color="grey darken-3"
                        content-class="my-tooltip"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <span role="listitem">
                            <img
                              class="amen-icon"
                              src="../assets/newHomeIcons/IconLegend/wheelchair.svg"
                              alt="Wheelchair accessible"
                              v-bind="attrs"
                              v-on="on"
                            />
                          </span>
                        </template>
                        <span>Wheelchair Accessible</span>
                      </v-tooltip>

                      <v-tooltip
                        v-if="park.picnic"
                        bottom
                        dark
                        color="grey darken-3"
                        content-class="my-tooltip"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <span role="listitem">
                            <img
                              class="amen-icon"
                              src="../assets/newHomeIcons/IconLegend/picnic.svg"
                              alt="Picnic area available"
                              v-bind="attrs"
                              v-on="on"
                            />
                          </span>
                        </template>
                        <span>Picnic Area</span>
                      </v-tooltip>

                      <v-tooltip
                        v-if="park.firepits"
                        bottom
                        dark
                        color="grey darken-3"
                        content-class="my-tooltip"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <span role="listitem">
                            <img
                              class="amen-icon"
                              src="../assets/newHomeIcons/IconLegend/campfire.svg"
                              alt="Firepits available"
                              v-bind="attrs"
                              v-on="on"
                            />
                          </span>
                        </template>
                        <span>Firepits</span>
                      </v-tooltip>

                      <v-tooltip
                        v-if="park.museum"
                        bottom
                        dark
                        color="grey darken-3"
                        content-class="my-tooltip"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <span role="listitem">
                            <img
                              class="amen-icon"
                              src="../assets/newHomeIcons/IconLegend/museum.svg"
                              alt="Museum available"
                              v-bind="attrs"
                              v-on="on"
                            />
                          </span>
                        </template>
                        <span>Museum</span>
                      </v-tooltip>
                    </div>

                    <button
                      class="card-button"
                      @click="viewDayusePage(park)"
                      :aria-label="'View passes for ' + park.name"
                    >
                      View Passes
                    </button>
                  </div>
                </article>
              </section>

              <div id="mapContainer">
                <iframe
                  :src="mapUrl"
                  title="Interactive map showing locations of all Utah State Parks"
                  class="mapIframe"
                  aria-label="Interactive map of Utah State Parks"
                ></iframe>
              </div>
            </div>
          </div>
        </main>

        <Footer></Footer>
      </div>

      <CartDrawer
        :open="cartOpen"
        :cart="cart"
        @close="cartOpen = false"
        @update-qty="handleUpdateQty"
        @remove="handleRemoveLine"
      />

      <button
        v-if="!cartOpen && cart && cart.totalQuantity > 0"
        class="cart-float-tab"
        @click="cartOpen = true"
        aria-label="Open cart"
      >
        <span class="cart-float-count">{{ cart.totalQuantity }}</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#fff"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <circle cx="9" cy="21" r="1" />
          <circle cx="20" cy="21" r="1" />
          <path
            d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"
          />
        </svg>
      </button>
    </v-app>
  </div>
</template>

<script>
import Footer from "../components/Footer.vue";
import Header from "../components/Header.vue";
import CartDrawer from "../components/CartDrawer.vue";
import { shopifyCart } from "../services/shopifyCart";

import $ from "jquery";

import { parksJson } from "../assets/ParkFiles/newparks";

export default {
  name: "Home",
  components: {
    Footer,
    Header,
    CartDrawer,
  },
  data() {
    return {
      mobile: false,
      parks: parksJson,
      mobileSearch: false,
      park: "",
      searchFocused: false,
      selectedFilter: "All Parks",
      filterItems: [
        { name: "All Parks", icon: require("../assets/newHomeIcons/utah.svg") },
        {
          name: "Boating",
          icon: require("../assets/newHomeIcons/boating.svg"),
        },
        {
          name: "Camping",
          icon: require("../assets/newHomeIcons/camping.svg"),
        },
        {
          name: "Fishing",
          icon: require("../assets/newHomeIcons/fishing.svg"),
        },
        { name: "Hiking", icon: require("../assets/newHomeIcons/hiking.svg") },
        {
          name: "Mountain Biking",
          icon: require("../assets/newHomeIcons/biking.svg"),
        },
        {
          name: "Museums",
          icon: require("../assets/newHomeIcons/museums.svg"),
        },
        {
          name: "Off-Highway",
          icon: require("../assets/newHomeIcons/off-highway.svg"),
        },
        {
          name: "Golfing",
          icon: require("../assets/newHomeIcons/golf.svg"),
        },
      ],
      dialogLegend: false,
      homeHeroImg: "../assets/images/snowcanyon-small.jpg",
      cart: null,
      cartOpen: false,
    };
  },

  metaInfo() {
    return {
      title: "Parkspass",
      titleTemplate: null,
      meta: [{ name: "description", content: this.currentParkMeta }],
    };
  },
  mounted() {
    window.addEventListener("pageshow", function (event) {
      if (event.persisted) {
        window.location.reload();
      }
    });

    if (shopifyCart.cart) {
      this.cart = shopifyCart.cart;
    } else {
      shopifyCart.load().then((c) => {
        if (c) this.cart = c;
      });
    }
  },
  created() {
    var newParks = [];
    for (let i in this.parks) {
      if ((this.parks[i].abbr != "DANUAL") & (this.parks[i].abbr != "ANNUAL")) {
        newParks.push(this.parks[i]);
      }
    }
    this.parks = newParks;

    if ($(window).width() <= 720) {
      this.mobile = true;
    }

    if (!this.parkFromArg()) {
      window.addEventListener("popstate", this.statePopped);
    }
  },
  updated() {
    if (this.mobileSearch) {
      document.getElementById("autocomplete-mobile").click();
      this.searchFocused = true;
    }
  },
  methods: {
    viewDayusePage(park) {
      this.$router.push(`/parks/${park.abbr}/dayuse`).then(() => {
        window.scrollTo(0, 0);
      });
    },
    searchFocus() {
      this.searchFocused = true;
      if (this.mobile) {
        this.mobileSearch = true;
      }
    },
    searchBlur() {
      this.searchFocused = false;
    },
    parkFromArg: function () {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      if (urlParams.has("p")) {
        const parkAbbr = urlParams.get("p").toUpperCase();
        const reg = /^[A-Z]{6}$/;
        if (!reg.test(parkAbbr)) {
          return false;
        }
        var parkName = null;
        var abbr = null;
        for (var i = 0; i < this.parks.length; i++) {
          if (this.parks[i].abbr == parkAbbr) {
            parkName = this.parks[i].name;
            abbr = this.parks[i].abbr;
            this.routerPush(abbr);
            break;
          }
        }
        if (parkName != null && abbr != null) {
          return true;
        }
      }
      return false;
    },
    locationSelected: function () {
      var abbr;
      for (var i = 0; i < this.parks.length; i++) {
        if (this.parks[i].name == this.park) {
          abbr = this.parks[i].abbr;
          this.routerPush(abbr);
          break;
        }
      }
    },
    async handleUpdateQty(lineId, quantity) {
      this.cart = await shopifyCart.updateLineQuantity(lineId, quantity);
    },
    async handleRemoveLine(lineId) {
      this.cart = await shopifyCart.removeLine(lineId);
    },
    routerPush(abbr) {
      if (abbr == "UTFLIG") {
        this.$router.push(`/parks/${abbr}/camping`);
      } else {
        this.$router.push(`/parks/${abbr}/dayuse`);
      }
    },
  },
  computed: {
    mapUrl() {
      return `https://utahstateparksmap.replit.app/`;
    },
    filteredParks() {
      // If "All Parks" is selected, return everything
      if (this.selectedFilter === "All Parks") {
        return this.parks;
      }

      // Otherwise, filter based on the boolean property that matches the selected filter.
      switch (this.selectedFilter) {
        case "Boating":
          return this.parks.filter((park) => park.boating);
        case "Camping":
          return this.parks.filter((park) => park.camping);
        case "Fishing":
          return this.parks.filter((park) => park.fishing);
        case "Hiking":
          return this.parks.filter((park) => park.hiking);
        case "Mountain Biking":
          // If your data uses `park.biking` or `park.mountainBiking`—adjust accordingly
          return this.parks.filter((park) => park.biking);
        case "Museums":
          return this.parks.filter((park) => park.museum);
        case "Off-Highway":
          // If your data uses `park.offHighway` or `park.ohv`—adjust accordingly
          return this.parks.filter((park) => park.offHighway);
        case "Golfing":
          return this.parks.filter((park) => park.golf);
        default:
          return this.parks;
      }
    },
  },
};
</script>

<style>
.cart-float-tab {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1000;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  background-color: #727a35;
  color: #fff;
  border: none;
  border-radius: 8px 0 0 8px;
  padding: 12px 10px;
  cursor: pointer;
  box-shadow: -2px 2px 8px rgba(0, 0, 0, 0.2);
  transition: background-color 0.15s ease;
}
.cart-float-tab:hover {
  background-color: #87913e;
}
.cart-float-count {
  font-family: "Roboto", sans-serif;
  font-size: 15px;
  font-weight: 700;
  line-height: 1;
  color: #fff;
}
.v-list-item__title {
  color: #727a35 !important;
}
.v-list-item:hover {
  background-color: #727a3520;
}
.v-list-item--highlighted {
  background-color: #727a3540;
}
.v-list-item--link:before {
  background-color: none;
}
/* Global CSS: Ensure this style block is NOT scoped */
.v-tooltip__content.my-tooltip,
.v-tooltip__content.my-tooltip * {
  color: #fff !important;
  background-color: #424242 !important;
}
.v-text-field.v-text-field--enclosed {
  padding: unset !important;
  margin: 0px 20px 0px 20px !important;
}
</style>
<style scoped>
ul.icon-legend-grid {
  list-style: none;
  padding: 0;
  margin: 0;
}
.filter-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
/* Skip link for keyboard navigation */
.skip-link {
  position: absolute;
  top: -40px;
  left: 0;
  background: #000;
  color: #fff;
  padding: 8px 16px;
  z-index: 10000;
  text-decoration: none;
  font-weight: bold;
}

.skip-link:focus {
  outline: none;
}
.skip-link:focus-visible {
  top: 0;
  outline: 3px solid #005fcc;
  outline-offset: 2px;
}

/* Focus styles for accessibility */
/* Focus styles for accessibility - only show on keyboard navigation */
button:focus,
a:focus {
  outline: none;
}

button:focus-visible,
a:focus-visible {
  outline: 3px solid #005fcc;
  outline-offset: 2px;
}

.select-park:focus-within,
.select-park-mobile:focus-within {
  outline: none;
}
.select-park:focus-visible-within,
.select-park-mobile:focus-visible-within {
  outline: 3px solid #005fcc;
  outline-offset: 2px;
}

/* White X button */
.white-x-btn {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  float: right;
  margin-right: 16px;
  margin-top: -2px;
}

.white-x-btn:focus {
  outline: none;
}
.white-x-btn:focus-visible {
  outline: 3px solid #005fcc;
  outline-offset: 2px;
  border-radius: 4px;
}

.white-x {
  vertical-align: middle;
  height: 24px;
  display: block;
}

/* filter stuff */
.filter-item {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 10px;
  width: 115px;
  background: none;
  border: none;
  padding: 8px;
}

/* Default text color for the filter text (if you want) */
.filter-text {
  color: #414141;
  margin-bottom: 8px;
  text-align: center;
}

/* When a filter is "active," make text black, add underline */
.active-filter .filter-text {
  color: black;
  /* A quick underline can be done with border-bottom: */
  border-bottom: 2px solid black;
}

/* For turning an SVG or PNG icon black, you can use a CSS filter. 
   Adjust to your liking or omit if you have your own black icons. */
.active-filter img {
  filter: brightness(0) invert(0);
}
.icon-legend-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 16px;
}

.icon-legend-item {
  display: flex;
  align-items: center;
}

.icon-legend-item img {
  width: 24px;
  height: 24px;
  margin-right: 8px;
}
.legend-dialog-title {
  color: #2f2f2f;
  font-family: Roboto, sans-serif;
  font-size: 36px !important;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 20px;
}

/* Container for icon+label pairs */
.icon-legend-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 16px;
}

/* Each icon+label row */
.icon-legend-item {
  display: flex;
  align-items: center;
  margin-bottom: 8px; /* optional */
}

/* Icon label styling */
.icon-legend-item span {
  color: #2f2f2f;
  font-family: Roboto, sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: normal; /* or a numeric value if desired */
  margin-left: 8px; /* space between icon & label */
}

#above-passes {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 66%;
  margin-left: 25px;
  margin-top: 25px;
}
#above-passes2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 305px;
}
.subheading {
  color: #414141;
  font-family: Roboto;
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 34px;
}
#legend {
  color: #477ba1;
  text-align: right;
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 100% */
  letter-spacing: 0.4px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}

#legend:hover {
  text-decoration: underline;
}

#legend:focus {
  outline: none;
}
#legend:focus-visible {
  outline: 3px solid #005fcc;
  outline-offset: 2px;
  border-radius: 4px;
}

#location-num {
  color: #414141;
  text-align: right;
  font-family: Roboto;
  font-size: 24px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px;
  margin-bottom: 0px;
}
.icons {
  height: auto;
}
.button-cont {
  display: flex;
}
.card-button {
  border-radius: 8px;
  background: #727a35;
  color: #fff;
  text-align: center;
  font-family: "Roboto";
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 18px; /* 112.5% */
  letter-spacing: 0.4px;
  width: 100%;
  padding: 15px;
  border: none;
  cursor: pointer;
  margin-top: auto;
}

.card-button:hover {
  background: #5a6129;
}

.card-button:focus {
  outline: none;
}
.card-button:focus-visible {
  outline: 3px solid #005fcc;
  outline-offset: 2px;
}

.amen-icon {
  margin: 4px;
}
.park-name {
  color: #414141;
  font-family: Roboto;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 133.333% */
  letter-spacing: 0.4px;
  margin-bottom: 0px;
  margin-top: 15px;
}
.pass-type {
  color: #414141;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.4px;
  margin-bottom: 0px;
}
.location {
  display: flex;
  align-items: center;
}
.location-text {
  color: #414141;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
  letter-spacing: 0.4px;
  margin-bottom: 0px;
  margin-left: 10px;
}
.card-text-cont {
  padding: 10px 15px;
  display: flex;
  flex-direction: column;
  flex: 1;
}
.park-images {
  width: 100%;
  height: auto;
  object-fit: cover;
}
.park-card {
  width: 30%;
  margin-bottom: 25px;
  min-height: 440px;
  max-width: 260px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}
#bottom-section {
  margin-top: 1rem;
  display: flex;
}
#passes {
  width: 70%;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-evenly;
}
#mapContainer {
  width: 30%;
  height: 90vh;
}
#page-padding {
  margin: 3rem 5rem;
}
#filter-menu {
  display: flex;
  justify-content: center;
  padding: 0 20px;
  margin-top: 20px;
  align-items: center;
}
.filter-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 10px;
  width: 115px;
}
.filter-item > img {
  margin-bottom: 8px;
}
.select-park,
.select-park-mobile {
  z-index: 1;
  color: white;
  padding: 0px 8px !important;
  margin-top: 32px !important;
}
.select-park-mobile {
  margin-top: 6px !important;
}
html,
body {
  overflow-x: hidden !important;
}
::-webkit-scrollbar {
  width: 0px;
  background: transparent;
}
::placeholder {
  color: #ffffff;
  opacity: 1;
}

:-ms-input-placeholder {
  color: #ffffff;
}

::-ms-input-placeholder {
  color: #ffffff;
}
/* Home Page */
/* #homeImgContainer {
  background-image: url("../assets/HomeImages/homepage.png");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 400px;
} */
#homeImgContainer {
  position: relative;
  background-image: url("../assets/HomeImages/homepage.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  height: 400px;
}

#homeImgContainer::before {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.2); /* adjust darkness */
  pointer-events: none;
  height: 400px;
}

.home1 {
  color: #ffffff;
  font-size: 24px;
  font-family: "boldRoboto";
  margin: 0px;
}
.home2 {
  color: #ffffff;
  font-size: 48px;
  font-family: "boldRoboto";
  margin: 0px;
  line-height: 72px;
  padding-top: 24px;
}
.home3 {
  color: #ffffff;
  font-size: 24px;
  font-family: "Roboto";
  margin: 0px;
  margin-bottom: 30px;
}
.centered-home {
  position: relative;
  margin: 0 auto;
  text-align: center;
  max-width: 700px;
  font-family: "boldRoboto";
  z-index: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  padding-top: 80px;
}
.park-events-link {
  display: none;
}
@media only screen and (max-width: 425px) {
  .park-events-link {
    color: #fff;
    font-family: Korolev, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    text-decoration: none;
    margin-top: 10px;
    margin-bottom: 20px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
  }
}
.park-events-link:hover {
  text-decoration: underline;
}
.park-events-icon {
  width: 16px;
  height: 16px;
}
.search-page-wrap {
  padding: 8px;
  box-sizing: border-box;
}
.blackBack {
  background-color: #1e252b;
  height: 100vh;
}
.searchHeader {
  margin-top: 0px;
  color: white;
  font-size: 18px;
  margin-left: 16px;
  display: inline;
  padding-top: 16px;
}
.mobileSearch {
  background: #727a35;
  color: white;
  font-size: 20px;
  background-image: url("../assets/icons/magnifyingGlass.png");
  background-repeat: no-repeat;
  background-position: right center;
  background-size: 20px;
  box-shadow: none;
  -webkit-appearance: none;
  background-origin: content-box;
  border-radius: 20px;
  height: 56px;
  width: 100%;
  padding: 0px 32px;
  border: none;
  cursor: pointer;
  margin-top: 16px;
  padding-left: 26px !important;
  position: relative;
  width: 100%;
  box-sizing: border-box;
}
h1 {
  font-family: "boldRoboto";
  font-style: normal;
  font-weight: bold;
  font-size: 48px;
  line-height: 56px;
  margin: 0px;
  color: rgba(0, 0, 0, 0.86);
}
h2 {
  font-family: "boldRoboto";
  font-size: 36px;
}
h3 {
  font-family: "boldRoboto";
  font-size: 18px;
  margin: 0;
}
.mapIframe {
  width: 100%;
  height: 100%;
  display: block;
}

#signUpButton:hover {
  background: #5a6129;
  border-color: #5a6129;
}

#signUpButton:focus {
  outline: none;
}
#signUpButton:focus-visible {
  outline: 3px solid #005fcc;
  outline-offset: 2px;
}

@media only screen and (max-width: 850px) {
  .search {
    width: -webkit-fill-available;
    height: 48px;
    font-size: 16px;
    background-size: 16px;
  }
  #homeImgContainer {
    background-image: url("../assets/HomeImages/homepage.png");
    overflow-y: hidden !important;
  }
  .home1,
  .home3 {
    font-size: 14px;
  }
  .icons {
    height: auto;
  }
  .home2 {
    padding-top: 14px;
    font-size: 48px;
    line-height: 48px;
  }
}
@media only screen and (max-width: 600px) {
  .home2 {
    font-size: 30px;
  }
  .icons {
    height: auto;
  }
}
@media only screen and (max-height: 1000px) {
  .centered-home {
    margin-top: 0px;
  }
  .icons {
    height: auto;
  }
}
@media only screen and (max-height: 800px) {
  .centered-home {
    margin-top: 0px;
  }
  .icons {
    height: auto;
  }
}
@media only screen and (min-width: 600px) {
  #homeImgContainer {
    background-image: url("../assets/HomeImages/homepage.png");
  }
  .icons {
    height: auto;
  }
}
@media only screen and (max-width: 768px) {
  /* Make the filter menu scroll horizontally */
  #filter-menu {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; /* for smooth scrolling on iOS */
    justify-content: flex-start; /* Align items to the start */
  }
  /* Ensure each filter item doesn't shrink and displays inline */
  .filter-item {
    flex: 0 0 auto;
    margin-right: 10px; /* add spacing if needed */
  }
  #above-passes {
    flex-direction: column;
    align-items: flex-start;
  }
  .icons {
    height: auto;
  }
  #above-passes2 {
    flex-direction: row-reverse;
  }
  #bottom-section {
    flex-direction: column;
  }
  #passes {
    width: 100%;
  }
  .park-card {
    min-width: 260px;
  }
  #mapContainer {
    width: 100%;
    height: 700px;
  }
}
@media only screen and (max-width: 425px) {
  #page-padding {
    margin: 1rem 1rem;
  }
  .filter-text {
    font-size: 14px;
  }
  .filter-item {
    width: 56px;
  }
  #filter-menu {
    padding: unset;
  }
  .icons {
    height: auto;
  }
  .subheading {
    font-size: 24px;
    width: 300px;
  }
  #location-num {
    font-size: 20px;
  }
  #legend {
    font-size: 20px;
    padding-left: 20px;
  }
  #above-passes2 {
    justify-content: flex-end;
  }
  #above-passes {
    margin: 0px;
  }
  .park-card {
    max-width: unset;
    width: 100%;
    min-height: 497px;
  }
  #mapContainer {
    width: 100%;
    height: 450px;
  }
  .centered-home {
    margin-left: 20px;
    align-items: center;
  }
  .home2 {
    text-align: center;
    text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    font-family: Roboto;
    font-size: 36px;
    font-style: normal;
    font-weight: 800;
    line-height: 115.5%;
    width: 290px;
  }
  .home3 {
    margin-bottom: 20px;
  }
  .v-text-field.v-text-field--enclosed {
    width: 100%;
  }
}
@media only screen and (max-width: 375px) {
  .park-card {
    min-height: 468px;
  }
  .icons {
    height: auto;
  }
}
@media only screen and (max-width: 320px) {
  .park-card {
    min-height: 432px;
  }
  .icons {
    height: auto;
  }
}
</style>
